module.exports = __webpack_public_path__ + "img/65bd576.png";